import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { getRecentlySoldItems, type RecentlySoldItem } from '@/js/lib/api/item';
import { dynamicImageUrl } from '@/js/lib/helper/url';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentSoldItems',
  props: {
    categoryId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string;
};


const rootEl = ref<HTMLDivElement>();
const items = ref<RecentlySoldItem[]>([]);
const itemImageUrl = (imagePath: string) => dynamicImageUrl(imagePath, 310, 310);
const loadItems = async () => {
  const data = await getRecentlySoldItems({ categoryId: props.categoryId ? Number(props.categoryId) : undefined, limit: 24 });
  items.value.push(...data);
};

onMounted(() => {
  if ('IntersectionObserver' in window) {
    const rootElObserver = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          await loadItems();
          rootElObserver.unobserve(rootEl.value);
        }
      });
    });
    rootElObserver.observe(rootEl.value);
  }
});

return { __sfc: true,props, rootEl, items, itemImageUrl, loadItems }
}

})